module.exports = __webpack_public_path__ + "img/logo_control.7c1b9ca7.png";